import React from 'react';

// Actions
import UserActions from '../../../actions/UserActions';
import UIActions from '../../../actions/UIActions';

// Scaffolding
import OuterScaffold from '../OuterScaffold.react';
import Card from '../Card.react';
import Container from '../Container.react';

// Form items
import Input from '../forms/Input.react'
import Button from '../buttons/Button.react'

// Headings
import H1 from '../headers/H1.react'
import H3 from '../headers/H3.react'

// Functions
import validate from '../../../functions/validate'

// Sets validation
const emailValidation = [
    {
        type: "min-length",
        value: 6
    },
    {
        type: "contains",
        value: "@"
    },
    {
        type: "contains",
        value: "."
    }
];

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this._updateFn = this._updateFn.bind(this);
        this._onClick = this._onClick.bind(this);

        this.state = {email: "", loading: this.props.status.indexOf("resettting password") > -1, validate: false}
    }

    componentDidMount(){
        document.getElementById("email").focus();
    }

    componentWillReceiveProps (nextProps){
       this.setState({loading: nextProps.status.indexOf("resetting password") > -1});
    }

    _onClick () {
        var emailError = validate(emailValidation, this.state.email);

        if (emailError === "") {
            this.setState({loading: true, validate: false});
            UserActions.resetPassword({email: this.state.email});
        } else
            this.setState({validate: true});
    }

    _updateFn (field, location, value) {
        this.setState({[field]: value, validate: false});
    }

    _onBack () {
        UIActions.show("login");
    }

    render () {
        const cardStyle = {
            width: "calc(100% - 16px)",            
            padding: "16px",
            textAlign: "center"
        };

        const rowStyle = {
            width: "100%",
            textAlign: "right",
            margin: "16px 0px 0px 0px"
        };

        const logoStyle = {
            height: "100px",
            marginBottom: "30px"
        };

        const forgotStyle = {
            marginRight: "16px"
        };

        return (
            <OuterScaffold>
                <Container maxWidth="500px">
                    <img src={"/images/logo_white_bg@2x.png"} style={logoStyle} alt=""/>
                    <Card style={cardStyle}>
                        <H1 text="Forgot Password" textAlign="center" margin="0px"/>
                        <H3 text="Need a password reset? Please enter your email below." textAlign="center" fontSize="20px" lineHeight="24px" margin="16px 0px" />
                        <Input 
                            id="email" 
                            label="Email" 
                            field="email"
                            updateFn={this._updateFn}
                            validate={this.state.validate}
                            validation={emailValidation}
                            onReturn={this._onClick}
                            errors={this.props.errors}
                        />
                        <div style={rowStyle}>
                            <Button text="Back" style={forgotStyle} onClick={this._onBack} type="flat" />
                            <Button text="RESET PASSWORD" onClick={this._onClick} loading={this.state.loading} />
                        </div>
                    </Card>
                </Container>
            </OuterScaffold>
        );
    }
}

export default ResetPassword;
